module.exports = __webpack_public_path__ + "e6dd1ff166546ec783f70d4d19b924e3.pdf";